import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { getJournal } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

export default function Journal() {
    const [posts, setPosts] = useState(null);

    useEffect(() => {
        getJournal().then(setPosts).catch(() => setPosts([]));
    }, []);

    return (
        <main className="bg-[#F6F1E7] min-h-screen pt-28 sm:pt-36 pb-24" data-testid="journal-page">
            <div className="max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-12">
                <Reveal className="text-center mb-16">
                    <p className="eyebrow text-[#8C6A3D] mb-4">The Journal</p>
                    <h1 className="font-serif-display text-5xl sm:text-6xl font-medium text-[#0B0B0C]">
                        Field notes, craft
                        <br />
                        <span className="italic font-normal">&amp; recipes.</span>
                    </h1>
                </Reveal>

                {!posts ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {[...Array(6)].map((_, i) => (
                            <Skeleton key={i} className="h-96 rounded-xl bg-black/[0.06]" />
                        ))}
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {posts.map((post, i) => (
                            <Reveal key={post.id} delay={Math.min(i * 0.07, 0.3)}>
                                <Link
                                    to={`/journal/${post.slug}`}
                                    className="group block"
                                    data-testid={`journal-card-${post.slug}`}
                                >
                                    <div className="rounded-xl overflow-hidden">
                                        <img
                                            src={post.hero_image}
                                            alt={post.title}
                                            loading="lazy"
                                            className="w-full aspect-[4/3] object-cover group-hover:scale-[1.04] transition-transform duration-700"
                                        />
                                    </div>
                                    <div className="pt-6">
                                        <p className="font-mono-meta text-[10px] tracking-[0.22em] text-[#8C6A3D]">
                                            {post.category.toUpperCase()} · {post.read_time.toUpperCase()}
                                        </p>
                                        <h2 className="font-serif-display text-2xl font-medium mt-3 leading-snug group-hover:text-[#0F2A1F] transition-colors">
                                            {post.title}
                                        </h2>
                                        <p className="text-sm text-black/55 mt-3 leading-relaxed line-clamp-2">{post.excerpt}</p>
                                    </div>
                                </Link>
                            </Reveal>
                        ))}
                    </div>
                )}
            </div>
        </main>
    );
}
